import React from 'react'

const MonthlySecureLoan = () => {
    return (
        <div className='max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 flex flex-col gap-8'>
            <div>
                <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mb-4">
                    Monthly Secure Loan
                </h2>
                <p className="text-md text-gray-600 mx-auto leading-relaxed">
                    A Monthly Loan is a type of short-term financing where the borrower is required to make repayments on a daily basis rather than monthly or weekly. These loans are typically designed for small businesses or individuals who need quick access to cash and can repay the loan with frequent, smaller installments. Daily loans are often used to manage working capital, cover operational costs, or handle emergencies.                </p>
            </div>
        </div>
    )
}

export default MonthlySecureLoan
